<template>
  <div>
    <div
      class="text"
      v-loading="loading"
      element-loading-background="rgba(16,164,178, 0.2)"
    >
      {{ text }}
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      text: "",
    };
  },
  components: {},
  props: ["analyze"],
  computed: {},
  beforeMount() {},
  mounted() {
    this.abstract();
  },
  methods: {
    async abstract() {
      this.loading = true;
      let data = { content: this.analyze };
      const { data: res } = await this.$http.post("/nlpir/summary", data);
      this.loading = false;
      this.text = res;
    },
  },
  watch: {},
};
</script>
<style scoped>
.text {
  width: 100%;
  height: 100%;
  padding: 10px;
  box-sizing: border-box;
  overflow: auto;
  font-family: serif;
}
</style>
